import { Capacitor } from "@capacitor/core";
import assertNever from "assert-never";
import { AndroidSettings, IOSSettings, NativeSettings } from "capacitor-native-settings";
import ons from "onsenui";

export enum CordovaPlugin {
  SocialSharing,
  LaunchNavigator,
}

async function notCordovaBuildErrorDialog(): Promise<void> {
  await ons.notification.alert({
    animation: "none",
    modifier: "material",
    title: "Not Cordova",
    message: "This is not a native Cordova build, so plugins are not available",
    cancelable: true,
  });
}

async function missingPluginErrorDialog(pluginName: string): Promise<void> {
  await ons.notification.alert({
    animation: "none",
    modifier: "material",
    title: "Missing Cordova plugin",
    message: 'The plugin "' + pluginName + '" is not installed, or is not configured correctly',
    cancelable: true,
  });
}

export const canOpenAppSettings = () => {
  return Capacitor.isPluginAvailable("NativeSettings");
};

export const openApplicationSettings = () => {
  if (canOpenAppSettings()) {
    NativeSettings.open({
      optionAndroid: AndroidSettings.ApplicationDetails,
      optionIOS: IOSSettings.App,
    });
  }
};

export async function cordovaPluginAvailable(
  plugin: CordovaPlugin,
  popupDialog = true
): Promise<boolean> {
  if (!(<boolean>(<any>window).cordova) && popupDialog) {
    await notCordovaBuildErrorDialog();
    return false;
  }

  switch (plugin) {
    case CordovaPlugin.SocialSharing:
      if (
        !(<boolean>(window as any).plugins) ||
        !(<boolean>(window as any).plugins.socialsharing)
      ) {
        await missingPluginErrorDialog("cordova-plugin-x-socialsharing");
        return false;
      }
      return true;
    case CordovaPlugin.LaunchNavigator:
      if (!(<boolean>(<any>window).launchnavigator)) {
        await missingPluginErrorDialog("cordova-plugin-x-socialsharing");
        return false;
      }
      return true;
    default:
      return assertNever(plugin);
  }
}
